export default {
  not_configured:
    "We are experiencing technical issues with your request, please contact technical support.",
  chart_configuration_error:
    "Unknown Chart Type. Please Contact Tech Support for Configuration Assistance",
};
